import { render, staticRenderFns } from "./CreateAssessment.vue?vue&type=template&id=a364001e&scoped=true"
import script from "./CreateAssessment.vue?vue&type=script&lang=js"
export * from "./CreateAssessment.vue?vue&type=script&lang=js"
import style0 from "./CreateAssessment.vue?vue&type=style&index=0&id=a364001e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a364001e",
  null
  
)

export default component.exports